export default __webpack_public_path__ + "static/media/GetInTouch.2f5928a1.png";